import { isVisibleToCustomers } from '@esentai/core/features/productCategory/selectors';
import withAsyncRunner from '@esentai/core/hocs/withAsyncRunner';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import { moveCategoryDown } from '@/features/productsCategoryPage/actions';

import MoveDownButton from './component';

const mapStateToProps = (state, { itemId }) => ({
  isVisible: isVisibleToCustomers(state, itemId),
});

const mapDispatchToProps = (dispatch, { itemId }) => ({
  onClick: () => dispatch(moveCategoryDown(itemId)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withAsyncRunner({ runnerMethod: 'onClick' }),
)(MoveDownButton);
